module.exports = __webpack_public_path__ + "media/images/ioscor-loguito_verdeweb-121fd2684a10fe6fc041275264b58fbd.jpg";